"use client"

import { HttpTypes } from "@medusajs/types"
import { useRouter, useSearchParams } from "next/navigation"
import { getLocalizedName } from "i18n/medusa-helpers"
import Thumbnail from "@modules/products/components/thumbnail"

export default function SubcategoryPreview({ subcategory, categoryImage, locale }: {
  subcategory: HttpTypes.StoreProductCategory
  categoryImage?: string
  locale: string
}) {
  const router = useRouter()
  const searchParams = useSearchParams()
  
  const handleSubcategoryClick = () => {
    const params = new URLSearchParams(searchParams)
    params.set('category', subcategory.id)
    params.set('page', '1')
    router.replace(`?${params.toString()}`, { scroll: false })
  }

  return (
    <button onClick={handleSubcategoryClick} className="group w-full text-left">
      <Thumbnail 
        thumbnail={categoryImage}
        size="square"
        className="mb-4"
      />
      <div className="text-sm font-medium text-gray-900">
        {getLocalizedName(subcategory, locale)}
      </div>
    </button>
  )
}